import React, { useEffect, useMemo, useState } from 'react';
import AddEditModalContent from './AddEditModalContent';
import { messages } from "../../../../../../messages.js";
import { config } from "../../../../../../config";
import close from "../../../../../../assets/close.svg";
import { maskingToPlainNumber, validateEmail } from '../../../../../../Util/helper';
import ModifyAdminPriviliges from '../../../../../../Util/DataTable/ModalContentAdmin/ModifyAccountPrivileges/ModifyAccountPrivileges';
import axiosApi from '../../../../../../core/interceptor/interceptor';
import _ from 'lodash';

const userType = 'admin';

export default function AddEditAdminModal(props) {
    /**** Show/Hide Priviliges *****/
    const [showPriviliges, setShowPriviliges] = useState(false);
    const [emailExist, setEmailExist] = useState(false);
    const [priviliges, setPriviliges] = useState([]);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        cellPhone: '',
        secondaryPhone: '',
        password: '',
        confirmPassword: '',
    });

    /***** States of form ******/
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        cell_phone: '',
        secondary_phone: '',
        password: '',
        confirm_password: '',
    });

    const debouncedCheckEmailExistance = useMemo(
        () => _.debounce((email, id) => checkEmail(email, id), 1500),
        [],
    );
    const [checkingEmail, setCheckingEmail] = useState(false);

    useEffect(() => {
        if (validateEmail((formData.email || '').trim())) {
            debouncedCheckEmailExistance((formData.email || '').trim(), formData.id);
        }
        //eslint-disable-next-line
    }, [formData.email]);

    useEffect(() => {
        handleValidation();
        //eslint-disable-next-line
    }, [
        formData.first_name,
        formData.last_name,
        formData.email,
        formData.password,
        formData.confirm_password,
        formData.cell_phone,
        formData.secondary_phone,
        emailExist,
    ]);

    const checkEmail = (email, id) => {
        setCheckingEmail(true);
        axiosApi.post(`${config.apiUrl}/misc/check-email-existance`, { email, id, user_type:'admin' })
            .then((res) => {
                setEmailExist(!!res.data.data);
                setCheckingEmail(false);
            })
            .catch((err) => {
                console.error(err);
                setCheckingEmail(false);
            });
    }

    /***** Triggers when form data changes ******/
    const handleFormChange = (event) => {
        setFormData((previousFormData) => ({
            ...previousFormData,
            [event.target.name]: event.target.value,
        }));
    }

    const handleValidation = () => {
        let errorArr = {};
        let formIsValid = true;

        /***** name validation ******/
        if (!formData['first_name']?.trim()) {
            formIsValid = false;
            errorArr["firstName"] = messages.emptyName;
        }

        /***** name validation ******/
        if (!formData['last_name']?.trim()) {
            formIsValid = false;
            errorArr["lastName"] = messages.emptyLastName;
        }

        /***** email validation ******/
        if (!formData['email']?.trim()) {
            formIsValid = false;
            errorArr["email"] = messages.emptyEmail;
        } else if (typeof formData['email'] !== "undefined") {
            if (!validateEmail(formData.email.trim())) {
                formIsValid = false;
                errorArr["email"] = messages.invalidEmail;
            }
            if (emailExist) {
                formIsValid = false;
                errorArr['email'] = messages.email_taken;
            }
        }

        /***** password validation ******/
        if (!formData['password']?.trim()) {
            formIsValid = false;
            errorArr["password"] = messages.emptyPassword;
        } else if (typeof formData['password'] !== "undefined") {
            if (formData['password'].length < 6) {
                formIsValid = false;
                errorArr["password"] = messages.passwordLength;
            }
        }

        /***** confirmPassword validation ******/
        if (!formData['confirm_password']?.trim()) {
            formIsValid = false;
            errorArr["confirmPassword"] = messages.emptyconfirmPassword;
        } else if (typeof formData['confirm_password'] !== "undefined") {
            if (formData['password'] !== formData['confirm_password']) {
                formIsValid = false;
                errorArr["confirmPassword"] = messages.confirmPasswordError;
            }
        }

        if(formData.cell_phone && formData.cell_phone.replace(/\D/g, '').length < 10) {
            formIsValid = false;
            errorArr['cellPhone'] = messages && messages.phoneLength;
        }
        if(formData.secondary_phone && formData.secondary_phone.replace(/\D/g, '').length < 10) {
            formIsValid = false;
            errorArr['secondaryPhone'] = messages && messages.phoneLength;
        }
        setErrors(errorArr);
        return formIsValid;
    }

    /**** Toast Message *****/
    const displayMessageHandler = (message) => {
        // toast(`${message}`, {
        //     className: 'errorToastNotification',
        //     bodyClassName: 'errorToastBody',
        //     progressClassName: 'errorToastProgressBar'
        // })
    }

    /**** Triggers when form submit *****/
    const handleSubmit = (event) => {
        event.preventDefault();
        const newPermissions = [...priviliges].sort();
        if (!newPermissions.length) {
            return displayMessageHandler(messages.selectOnePermission);
        }

        const data = {...formData};
        data.cell_phone = maskingToPlainNumber(data.cell_phone);
        data.secondary_phone = maskingToPlainNumber(data.secondary_phone);
        data.permissions = newPermissions;
        data.email = data.email.trim();
        data.first_name = data.first_name?.trim();
        data.last_name = data.last_name?.trim();
        data.password = data.password?.trim();
        data.confirm_password = data.confirm_password?.trim();
        axiosApi.post(`${config.apiUrl}/users/${userType}`, data)
            .then((res) => {
                closeModal(true);
            })
            .catch((error) => {
                console.error(error);
            });
        closeModal();
    }

    /*** Show/Hide Priviliges  *****/
    const showPrivilige = (e, checkValidation) => {
        e.preventDefault();
        setFormSubmitted(true);
        if (checkValidation) {
            if (handleValidation()) {
                setShowPriviliges(show => !show);
            }
        } else {
            setShowPriviliges(show => !show);
        }
    }

    /*** closes modal *****/
    const closeModal = (resp = false) => {
        if (props.closeModal) {
            props.closeModal(resp);
        }
    }

    return <>
        <div className="modal addAdminModal">
            <div className="modal-header">
                <h2>Add Administrator</h2>
                <p>{showPriviliges ? 'Show account priviliges' : 'Enter account info'}</p>
                <span className="close" onClick={() => closeModal()
                }>
                    <img src={close} alt='close-icon' />
                </span>
            </div>
            <form onSubmit={handleSubmit}>
                {
                    !showPriviliges
                        ? <AddEditModalContent checkingEmail={checkingEmail} formData={formData} handleFormChange={handleFormChange} formSubmitted={formSubmitted} errors={errors} />
                        : <ModifyAdminPriviliges permissions={setPriviliges} userId={null} />
                }
                {
                    showPriviliges
                        ? <div className="modal-footer d-flex">
                            <button className="cancel-btn" onClick={showPrivilige}>Back</button>
                            <button type="submit" >Create Administrator</button>
                        </div>
                        : <div className="modal-footer d-flex">
                            <button className="cancel-btn" onClick={closeModal}>Cancel</button>
                            <button type="button" onClick={(e) => showPrivilige(e, true)}>Continue to Priviliges</button>
                        </div>
                }
            </form>
        </div>
    </>
}